import { render, staticRenderFns } from "./MatterInvoice.vue?vue&type=template&id=9ee8de36"
import script from "./MatterInvoice.vue?vue&type=script&lang=js"
export * from "./MatterInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports